import {initializeSearchObject} from "../types/SearchTypes";
import {dateToUTCTimezone} from "../common/date";
import {snakeToCamelCase} from "../common/common";

export const getApartmentList = (resorts) => {
    if (!resorts) {
        return undefined;
    }

    let apartmentList = [];
    resorts.forEach(resort => {

        return resort?.apartments?.forEach(apartment => {
            apartmentList.push({
                resortId: resort.id,
                resortName: resort.resort_name,
                shortCode: apartment.category,
                categoryName: apartment.description,
                availability: apartment.category_availability,
            });
        });
    });

    return apartmentList;
};

export const getResortsLabel = (resorts, selectedCountries, selectedDestinations) => {
    let resortsLabel = "";

    selectedCountries?.forEach(country => {
        resortsLabel += country + ", ";
    });

    selectedDestinations?.forEach(resortsDestination => {
        if (!resortsDestination?.resorts?.some(resort => selectedCountries.includes(resort.destination?.country?.country))) {
            resortsLabel += resortsDestination?.destination + ", ";
        }
    });

    if (resortsLabel.endsWith(", ")) {
        resortsLabel = resortsLabel.slice(0, resortsLabel.length - 2);
    }

    return resortsLabel;
};

export const getResortsToDisplayList = (selectedCountries, selectedDestinations, partnerResortsLabel) => {
    const resortsList = [];

    selectedCountries?.forEach(country => {
        resortsList.push(country);
    });

    selectedDestinations?.forEach(resortsDestination => {
        if (!resortsDestination?.resorts?.some(resort => selectedCountries.includes(resort.destination?.country?.country) || resort.isPartner && selectedCountries.includes(partnerResortsLabel))) {
            resortsList.push(resortsDestination?.destination);
        }
    });

    return resortsList;
};

export const getGroupedByCountry = (resorts, isFromUrl = false) => {
    if (!resorts) {
        return undefined;
    }

    let groupedByCountry;

    if(isFromUrl) {
        groupedByCountry = transformDestinations(resorts).reduce(function (result, resort) {
            result[resort.country] = result[resort.country] || [];
            result[resort.country].push(resort.resorts[0]);
            return result;
        }, {});
    }
    else {
        groupedByCountry = resorts.reduce(function (result, resort) {
            result[resort.country] = result[resort.country] || [];
            result[resort.country].push(resort);
            return result;
        }, {});
    }

    groupedByCountry = Object.keys(groupedByCountry)
        .sort(function (a, b) {
            return a.localeCompare(b);
        })
        .reduce((acc, key) => ({
            ...acc, [key]: groupedByCountry[key]?.sort(function (a, b) {
                return a?.destination?.destination?.localeCompare(b?.destination?.destination);
            })
        }), {});

    return groupedByCountry;
};

export const transformDestinations = (resorts) => {
    if (!resorts) {
        return undefined;
    }

    let result = resorts.map(function(resort) {
        return {
            destination: resort?.resortName,
            destinationSlug: resort?.destination?.slug,
            resorts: [resort],
            country: resort?.destination?.country?.country,
            countrySlug: resort?.destination?.country?.slug,
            searchableFields: ("".concat(resort?.resortName, " ", resort?.destination?.destination, " ", resort?.destination?.country?.country)).toLowerCase(),
            isPartner: resort?.isPartner
        };
    });

    return result.sort(function(a, b) {
        let x = a?.destination?.toLowerCase();
        let y = b?.destination?.toLowerCase();
        return x < y ? -1 : x > y ? 1 : 0;
    });
};


export const getSumOfImages = (apartments, listOfItems) => {
    if (!apartments) {
        return undefined;
    }
    return apartments.reduce( (sum, acc) => sum + acc[listOfItems].items.length, 0);
};

export const getUniqueResortTags = (resorts) => {
    if (!resorts) {
        return undefined;
    }

    let result = [...resorts];
    result?.forEach( resort => {
        let tags = resort?.resort_tags;
        tags = tags.reduce(function(a, b){
            if (a.indexOf(b) < 0) {
                a.push(b);
            }
            return a;
        }, []);

        resort.resort_tags = tags;
        return resort;
    });

    return result;
};

export const setValuesToHighlights = (resorts, resortIds, searchPressedFilters, state, stateUpdated, highlightsUpdated, activities, preferences) => {

    let result = {};
    result.resortIds = {...resortIds};
    result.searchPressedFilters = searchPressedFilters;
    result.state = {...state};
    result.stateUpdated = {...stateUpdated};
    result.highlightsUpdated = {...highlightsUpdated};

    if (activities?.resortPositioningEntryCollection?.items) {
        activities?.resortPositioningEntryCollection?.items.forEach((activity) => {
            result.highlightsUpdated[activity.title] = 0;
        });
    }

    if (preferences?.resortPositioningEntryCollection?.items) {
        preferences?.resortPositioningEntryCollection?.items.forEach((preference) => {
            result.highlightsUpdated[preference.title] = 0;
        });
    }

    resorts?.forEach( resort => {
        resort?.filters?.highlights.forEach(highlight => {
            !result.resortIds[highlight] ? result.resortIds[highlight] = [resort.id] : result.resortIds[highlight].push(resort.id);
            !result.searchPressedFilters && result.state[highlight] !== undefined ? result.stateUpdated[highlight] = result.state[highlight] : result.stateUpdated[highlight] = false;
            result.highlightsUpdated[highlight] = (result.highlightsUpdated[highlight] + 1) || 1;
        });
    });

    return result;
};

export const setValuesToHighlightsUpdatedAndResortIds = (resorts, resortIds, highlightsUpdated, activities, preferences) => {

    let result = {};
    result.resortIds = {...resortIds};
    result.highlightsUpdated = {...highlightsUpdated};

    if (activities?.resortPositioningEntryCollection?.items) {
        activities?.resortPositioningEntryCollection?.items.forEach((activity) => {
            result.highlightsUpdated[activity.title] = 0;
        });
    }

    if (preferences?.resortPositioningEntryCollection?.items) {
        preferences?.resortPositioningEntryCollection?.items.forEach((preference) => {
            result.highlightsUpdated[preference.title] = 0;
        });
    }

    resorts?.forEach( resort => {
        resort?.filters?.highlights.forEach(highlight => {
            !result.resortIds[highlight] ? result.resortIds[highlight] = [resort.id] : result.resortIds[highlight].push(resort.id);
            result.highlightsUpdated[highlight] = (result.highlightsUpdated[highlight] + 1) || 1;
        });
    });

    return result;
};

export const setActionHighlightsUpdatedWhenUncheked = (highlightsUpdated, uncheckedResort, state, resorts, resortIds, resortsUpdated ) => {

    Object.keys(highlightsUpdated)?.map((highlight) => {

        if (uncheckedResort) {
            if (state[highlight]) {

                resorts?.forEach(resort => {
                    if (!resortIds[highlight].includes(resort.id)) {
                        const resortIndex = resortsUpdated.indexOf(resort);
                        if (resortIndex !== -1) {
                            resortsUpdated.splice(resortIndex, 1);
                        }
                    }

                });
            }
        }
    });
};

export const getCountriesSelected = (resortIds, countries) => {

    let result = [];
    const checkIfExists = (element) => {
        return resortIds.includes(element);
    };

    Object.keys(countries)?.map((country) => {
        if (countries[country].map(resort => resort.hapimagResortId.toString()).every(element => checkIfExists(element))) {
            result.push(country);
        }
    });
    return result;

};

export const getDestinationsSelected = (resortIds, resortsDestination) => {

    let result = [];
    const checkIfExists = (element) => {
        return resortIds.includes(element);
    };

    Object.keys(resortsDestination)?.map((destination) => {
        if (resortsDestination[destination]?.resorts?.map(resort => resort.hapimagResortId.toString()).every(element => checkIfExists(element))) {
            result.push(resortsDestination[destination]);
        }
    });
    return result;

};

export const getSearchObjFromURL = (urlVariables, nonPartnerResorts, partnerResorts, partnerResortsLabel = []) => {
    let searchObj = initializeSearchObject();

    if (urlVariables) {

        if (urlVariables.resort_id && typeof urlVariables.resort_id !== "number") {
            if (urlVariables.resort_id?.length === nonPartnerResorts?.concat(partnerResorts).length || !urlVariables.resort_id) {
                searchObj.selectedResortsAll = true;
            } else {
                const groupedCountries = getGroupedByCountry(nonPartnerResorts, true);
                if (partnerResorts.length > 0) {
                    groupedCountries[partnerResortsLabel] = partnerResorts;
                }

                const transformedDestinations = transformDestinations(nonPartnerResorts?.concat(partnerResorts));

                searchObj.selectedResortsAll = false;
                searchObj.selectedCountries = getCountriesSelected(urlVariables.resort_id, groupedCountries);
                searchObj.selectedDestinations = getDestinationsSelected(urlVariables.resort_id, transformedDestinations);
            }
        }

        if (urlVariables.number_of_guests) {
            searchObj.guests = parseInt(urlVariables.number_of_guests);
        }

        if (urlVariables.highlights){
            searchObj.highlights = urlVariables.highlights;
        }

        if (urlVariables.wheelchair_accessible) {
            searchObj.wheelchairAccessible = (urlVariables.wheelchair_accessible === "true");
        }

        if (urlVariables.date_to && urlVariables.date_from) {
            searchObj.dateFrom = dateToUTCTimezone(urlVariables.date_from);
            searchObj.dateTo = dateToUTCTimezone(urlVariables.date_to);

            if (urlVariables.flexible_dates) {
                searchObj.flexibleDates = urlVariables.flexible_dates;
            }
        }
    }
    return searchObj;
};

export const transformResorts = (resorts) => {
    if (resorts && resorts.length) {
        return resorts.map(resort => snakeToCamelCase(resort));
    }
};
